import * as React from 'react';
import { Checkbox } from '../../Checkbox';
import { AssetShareTargetGroup } from './types';

type AssetCheckboxClientGroupCheckboxProps = {
    areAllLocationsChecked: boolean;
    areAllLocationsDisabled: boolean;
    client: AssetShareTargetGroup;
    disabled: ReadonlyArray<string>;
    isAtLeastOneLocationChecked: boolean;
    onChange: (selected: string[]) => void;
    selected: ReadonlyArray<string>;
};

export const AssetCheckboxClientGroupCheckbox = ({
    areAllLocationsChecked,
    areAllLocationsDisabled,
    client,
    disabled,
    isAtLeastOneLocationChecked,
    onChange,
    selected,
}: AssetCheckboxClientGroupCheckboxProps): JSX.Element => (
    <Checkbox
        checked={areAllLocationsChecked}
        disabled={areAllLocationsDisabled}
        indeterminate={isAtLeastOneLocationChecked && !areAllLocationsChecked}
        key={client.id}
        type="checkbox"
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const locationIds = client.items
                .filter(
                    location =>
                        !disabled.includes(location.id) && location.maxCollections - location.currentCollections > 0,
                )
                .map(({ id }) => id);
            if (event.target.checked) {
                onChange([...selected, ...locationIds]);
            } else {
                onChange(selected.filter(id => !locationIds.includes(id)));
            }
        }}
    >
        {client.title}
    </Checkbox>
);
AssetCheckboxClientGroupCheckbox.displayName = 'AssetCheckboxClientGroupCheckbox';
